import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setCabinetNavigationFilterCompleted,
  setCountertopNavigationFilterCompleted, setNavigationViewType
} from "../../../../actions/navigationFunctions";
import {CABINET_WIZARD_BUTTONS, COUNTERTOP_WIZARD_BUTTONS} from "../../../kvComponent/core/constants";
import {setSelectedFilters} from "../../../../actions/actionFunctions";

class NavigationFiltersSteps extends Component {

  static propTypes = {
    availableSteps: PropTypes.array,
    setFeatureWizardStep: PropTypes.func,
    exitFeatureWizard: PropTypes.func,
    showFeatureWizard: PropTypes.bool,
    isMobile: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({
          mounted: true
        });
      }
    }, 0)
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  exitFeatureWizard = () => {
    this.props.setActiveNavigationFilter(CABINET_WIZARD_BUTTONS[0].buttonId);
    this.props.setActiveNavigationFilterStepIndex(0);
    const cabinetPartIds = ["top_cabinet", "bottom_cabinet"];
    const countertopPartIds = ["countertop", "center_island_countertop", "edge_profile", "center_island_edge", "backsplash"];
    if (cabinetPartIds.includes(this.props.activePart.partId)) {
      this.props.setCabinetNavigationFilterCompleted(true);
    } else if (countertopPartIds.includes(this.props.activePart.partId)) {
      this.props.setCountertopNavigationFilterCompleted(true);
    }
  };

  getAvailableSteps = () => {
    let wizardButtons = [];
    switch (this.props.activePart.partId) {
      case "top_cabinet":
      case "bottom_cabinet":
        wizardButtons = CABINET_WIZARD_BUTTONS.filter(wizardButton => {
          if (wizardButton.buttonId === "all_products") {
            return this.props.isMobile
          }
          return wizardButton.buttonId !== "inlay_type"
        });
        break;
      case "countertop":
      case "edge_profile":
      case "backsplash":
        wizardButtons = COUNTERTOP_WIZARD_BUTTONS;
        break;
      case "center_island_countertop":
      case "center_island_edge":
        wizardButtons = COUNTERTOP_WIZARD_BUTTONS.slice(0, 4);
        break;
    }
    return wizardButtons;
  };

  setFeatureWizardStep = (nextStepIndex, disabled = false, lastStep) => {

    if (disabled) {
      return false;
    }
    const availableSteps = this.getAvailableSteps();
    if (lastStep) {
      this.exitFeatureWizard();
    } else {
      this.props.setActiveNavigationFilter(availableSteps[nextStepIndex].buttonId);
      this.props.setActiveNavigationFilterStepIndex(nextStepIndex);
    }
    const commonView = (this.props.windowWidth < 991) ? 4 : 3;
    const buttonId = availableSteps[nextStepIndex].buttonId;
    if (buttonId === COUNTERTOP_WIZARD_BUTTONS[2].buttonId) {
      this.props.setNavigationViewType(2)
    } else if (this.props.navigationViewType !== commonView) {
      this.props.setNavigationViewType(commonView)
    }
    if (buttonId !== COUNTERTOP_WIZARD_BUTTONS[2].buttonId) {
      this.props.setSelectedFilters([]); // reset filters on finish filters
    }
  };

  render() {
    const availableSteps = this.getAvailableSteps();
    const currentActiveIndex =  this.props.activeNavigationFilterStepIndex;

    const firstStepIsActive = currentActiveIndex === 0;
    const lastStepIsActive = currentActiveIndex === availableSteps.length - 1;

    const cabinetNavigationFilterCompleted = this.props.isMobile && this.props.cabinetNavigationFilterCompleted && (
      this.props.activePart.partId === "top_cabinet" || this.props.activePart.partId === "bottom_cabinet"
    );
    // const countertopNavigationFilterCompleted = this.props.isMobile && this.props.countertopNavigationFilterCompleted && (
    //   this.props.activePart.partId === "countertop" || this.props.activePart.partId === "center_island_countertop"
    // );

    const countertopWizardPartIds = ["countertop", "center_island_countertop", "edge_profile", "center_island_edge", "backsplash"];
    const isCountertopWizard = countertopWizardPartIds.includes(this.props.activePart.partId);

    return (
      <div className={"wiz-wrapper" + (this.state.mounted && !this.props.isMobile ? " wiz-wrapper--mounted" : "")
      + (this.props.isMobile ? " wiz-wrapper--mobile" : "")}>
        {this.props.isMobile ? null : (
          <div className="wiz-header">
            <span className="wiz-header__title">
              {availableSteps[currentActiveIndex]
                ? `Select a ${availableSteps[currentActiveIndex].text} for your ${this.props.activePart.partName}.`
                : null}
            </span>
            {isCountertopWizard ? null : <button className="ui-close wiz-header__button" onClick={this.exitFeatureWizard}>
              <FormattedMessage id="filterSelection.wizard.exit"/>
            </button>}
          </div>
        )}
        <div className={"wiz" + (this.props.isMobile ? "" : " wiz--desktop")}>
          {cabinetNavigationFilterCompleted ? null : (
            <div className={"wiz__arrow wiz__arrow--left" + (firstStepIsActive ? " wiz__arrow--disabled" : "")}
                 onClick={() => this.setFeatureWizardStep(currentActiveIndex - 1, firstStepIsActive)}>
              <span><FormattedMessage id="filterSelection.wizard.back"/></span>
            </div>
          )}
          <ul className={"wiz__button-list"
          + (this.props.isMobile ? " wiz__button-list--"+currentActiveIndex : " wiz__button-list--0")
          + (this.props.isMobile ? " wiz__button-list--total-items-"+availableSteps.length : "")
          + (cabinetNavigationFilterCompleted ? " wiz__button-list--completed" : "")
          }>
            {availableSteps.map((wizardButton, index) => {
              const disabled = false;
              const buttonIcon = isCountertopWizard && wizardButton.buttonId === "all_products" ? "stones" : wizardButton.buttonId;
              return (
                <li className={"wiz__button wiz__button--" + buttonIcon
                + (index === this.props.activeNavigationFilterStepIndex ? " wiz__button--active" : "")}
                    key={"wizardButton"+index} onClick={() => this.setFeatureWizardStep(index, disabled)}>
                  <span className="panel-wizard-list__button-text">{wizardButton.text}</span>
                </li>
              )
            })}
          </ul>
          {cabinetNavigationFilterCompleted ? null : (
            <div className={"wiz__arrow wiz__arrow--right" + (lastStepIsActive && isCountertopWizard ? " wiz__arrow--disabled" : " wiz__arrow--blinking")}
                 onClick={() => this.setFeatureWizardStep(
                   currentActiveIndex + 1,
                   lastStepIsActive && isCountertopWizard,
                   lastStepIsActive && !isCountertopWizard
                 )}>
              <span>
                <FormattedMessage id={lastStepIsActive
                  ? isCountertopWizard ? "filterSelection.wizard.next" : "filterSelection.wizard.finish"
                  : "filterSelection.wizard.next"}/>
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }
}


const mapStateToProps = (store) => ({
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  activeNavigationFilterStepIndex: store.navigationState.activeNavigationFilterStepIndex,
  cabinetNavigationFilterCompleted: store.navigationState.cabinetNavigationFilterCompleted,
  countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
  navigationViewType: store.navigationState.navigationViewType,
  windowWidth: store.serverState.windowWidth,
});

const mapDispatchToProps = {
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setCabinetNavigationFilterCompleted,
  setCountertopNavigationFilterCompleted,
  setNavigationViewType,
  setSelectedFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationFiltersSteps);
